import gql from 'graphql-tag'
export const projectFragment = gql`
    fragment projectFragment on Project{
        id
        name
        externalID
        workforce_request_number
        workforce_change_number
        description
        internal_notes
        contract_number
        start_date
        end_date
        status
        hasNotificationsReady
        hasPartnerNotificationsReady
    }
`
export const projectSummaryFragment = gql`
    fragment projectSummaryFragment on Project{
        id
        name
        externalID
        workforce_request_number
        workforce_change_number
        description
        internal_notes
        contract_number
        start_date
        end_date
        status
        hasNotificationsReady
        hasPartnerNotificationsReady
        assignmentsSummary(
            dateRange: $shiftsDateRange
        ) {
            assignmentsCount
            datedAssignments{
                count
                unassigned
                pending
                accepted
                denied
                maybe
                hasDraftShift
                date
                draftCount
                assignmentErrorCount
                absenceErrorCount
            }
        }
    }
`
export const projectSummaryFragmentShort = gql`
    fragment projectSummaryFragmentShort on Project{
        id
        name
        description
        status
        assignmentsSummary(
            dateRange: $shiftsDateRange
        ) {
            assignmentsCount
            datedAssignments{
                count
                unassigned
                pending
                accepted
                denied
                maybe
                hasDraftShift
                date
                draftCount
                assignmentErrorCount
                absenceErrorCount
            }
        }
    }
`